/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, Select, DatePicker, message, Row, Col } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { ProvinceSelector, CitySelector } from '../../common';
import { FORM_HIDE_TIMEOUT_SECONDS, ZONES } from '../../../config/config';
import { Cards } from '../../../components/cards/frame/cards-frame';

const initialState = {
  title: '',
  contact: '',
  email: '',
  website: '',
  membership_number: '',
  registration_date: null,
  province_id: null,
  city_id: null,
};
const { Option } = Select;

const FormDialog = ({ showDialog, disableOutSideCLose = false, isEdit = false, setReload, editId }) => {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const [resetSelectors, setResetSelectors] = useState(false);

  const [zoneID, setZoneID] = useState(null);
  const [provID, setProvID] = useState(null);
  const [provName, setProvName] = useState(null);

  const [citID, setCITID] = useState(null);
  const [citName, setCitName] = useState(null);

  const fetchCompanyData = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/comps/get-by-id', { id });
      if (response.data.status) {
        const mData = response.data.data;
        form.setFieldsValue({
          ...mData,
          registration_date: moment(mData.registration_date),
        });

        setZoneID(mData.zone_id)
        setCITID(mData.city_id)
        setProvID(mData.province_id)

        setCitName(mData.city_name)
        setProvName(mData.prov_name)
      } else {
        message.error(response.data.message || response.message)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching company data:', error);
      message.error(error.message)
    }
  };

  const fetchRegNumber = async () => {
    try {
      setBusy(true);
      const response = await DataService.post('/comps/get-reg-number');
      if (response.data.status) {
        const mData = response.data.data;
        form.setFieldsValue({ membership_number: (Number(mData) + 1) });
      } else {
        message.error(response.data.message || response.message)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching company data:', error);
      message.error(error.message)
    }
  };

  const handleSubmit = async (values) => {
    try {

      setBusy(true);
      const payload = {
        ...values,
        registration_date: values.registration_date.format('YYYY-MM-DD'),
        title: values.title.toUpperCase(),
        email: values.email.toUpperCase(),
        website: values.website?.toUpperCase(),
        city_id: citID,
        province_id: provID
      };

      const endpoint = isEdit ? '/comps/update' : '/comps/create';
      const response = await DataService.post(endpoint, { ...payload, id: editId });

      if (response.data.status) {
        message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
          showDialog(false);
          setReload(true);
        });
      } else {
        setBusy(false);
        message.error(`Error: ${response.data.message}`)
      }
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`)
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchCompanyData(editId);
    } else {
      fetchRegNumber()
    }
  }, [isEdit, editId]);

  const validateSelect = ({ field, type }) => {
    if (field === 'city_id') {
      if (!citID) {
        return Promise.reject(new Error('Please select a city!'));
      }
      return Promise.resolve();
    }
    if (field === 'zone_id') {
      if (!zoneID) {
        return Promise.reject(new Error('Please select a zone!'));
      }
      return Promise.resolve();
    }

    if (!provID) {
      return Promise.reject(new Error('Please select a province!'));
    }
    return Promise.resolve();
  };

  return (
    <Modal
      open
      title={isEdit ? 'Edit Company' : 'Add Company'}
      okText={isEdit ? 'Update' : 'Create'}
      cancelText="Cancel"
      width='70%'
      confirmLoading={busy}
      centered
      onCancel={(event) => {
        const { target, keyCode } = event
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false)
        if (keyCode === 27) showDialog(false)
      }}
      onOk={() => form.submit()}
      cancelButtonProps={{
        disabled: busy
      }}
      destroyOnClose
      closable={false}
    >
      <div style={{ maxHeight: '70vh', overflowY: 'auto', padding: '5px' }}>
        <Form
          layout="horizontal"
          form={form}
          name="company_form"
          onFinish={handleSubmit}
          // labelCol={{ span: 2 }} // Adjust label width
          // wrapperCol={{ span: 16 }} // Adjust input width
          disabled={busy}
          initialValues={initialState}
          onValuesChange={(changedValues, allValues) => {
            console.log('Form Values Updated:', allValues);
          }}
        >

          <Cards title="Basic Details" border className='!shadow'>
            <div className="flex flex-col text-center space-y-[-20px]">
              <Form.Item
                name="membership_number"
                label="Membership #"
              >
                <Input disabled placeholder="#" className='!text-black font-bold text-[20px] text-center' />
              </Form.Item>
              <span className='font-bold text-center ml-28' >System Generated (can not be changed !)</span>
            </div>
            <br />
            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="title"
                  label="Company Name"
                  rules={[
                    { required: true, max: 30, message: 'Please input the company name, length should not be more then 30!' },
                  ]}
                >
                  <Input placeholder="Enter Company Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[{ type: 'email', required: true, message: 'Please input the email!' }]}
                >
                  <Input placeholder="Enter Email" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col span={24}>
                <Form.Item
                  name="website"
                  label="Website (Optional)"
                  rules={[
                    { type: 'url', message: 'Please enter a valid web url!' },
                  ]}
                >
                  <Input placeholder="Enter Website" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="registration_date"
                  label="Registration Date"
                  rules={[
                    { required: true, message: 'Please select the registration date!' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="zone_id"
                  label="Select Zone"
                  validateTrigger="onBlur"
                  rules={[{ required: true, validator: validateSelect }]}
                >
                  <Select
                    placeholder="Select a zone"
                    optionFilterProp="children"
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onChange={value => setZoneID(value)}
                  >
                    {ZONES.map(item => <Option value={item.id}>{item.label}</Option>)}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="province_id"
                  label="Select Province"
                  rules={[
                    { required: true, message: 'Please select the province !', validator: validateSelect },
                  ]}
                >
                  <ProvinceSelector onItemSelected={selectedItem => {
                    setResetSelectors(true)
                    setCITID(null)
                    setProvID(selectedItem)
                  }}
                    defaultValue={provName}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="city_id"
                  label="Select City"
                  rules={[
                    { required: true, validator: validateSelect },
                  ]}
                >
                  <CitySelector
                    onItemSelected={selectedItem => setCITID(selectedItem)}
                    provinceID={provID}
                    defaultValue={citName}
                    resetForm={resetSelectors}
                    setResetForm={setResetSelectors}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="hq_address"
                  label="Head Office Address"
                  rules={[{ required: true, message: 'Please input the head office address!' }]}
                >
                  <Input placeholder="Enter Head Office Address" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="hq_contact"
                  label="Office Contact #"
                  rules={[{ required: true, message: 'Please input the head office contact number!' }]}
                >
                  <Input placeholder="Enter Head Office Contact Number" />
                </Form.Item>
              </Col>
            </Row>

          </Cards>
          <Cards title="Owner/CEO Details" border className='!shadow'>
            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="owner_name"
                  label="Name"
                  rules={[
                    { required: true, message: 'Please input the owner name!' },
                  ]}
                >
                  <Input placeholder="Enter Owner Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="owner_contact"
                  label="Contact"
                  rules={[{ required: true, message: 'Please input the owner contact!' }]}
                >
                  <Input placeholder="Enter Owner Contact" />
                </Form.Item>
              </Col>
            </Row>
          </Cards>
        </Form>
      </div>
    </Modal >
  );
};

export default FormDialog;
